<template>
  <div>
    <template v-if="details && ready">
      <v-layout wrap>
        <v-flex
          md4
          xs12
        >
          <v-card
            class="ma-1"
          >
            <v-container>
              <div>
                <span class="text-caption">{{ $t('tasks.state.name') + ': ' }}</span>
                {{ details.state | taskState }}
              </div>
              <div>
                <span class="text-caption">{{ $t('tasks.priority.name') + ': ' }}</span>
                {{ details.priority | taskPriority }}
              </div>
              <div>
                <span class="text-caption">{{ $t('tasks.assigned_user') + ': ' }}</span>
                {{ details.assigned_user | fullName }}
              </div>
              <div>
                <span class="text-caption">{{ $t('tasks.time_spent') + ': ' }}</span>
                {{ details.time_entries | timeEntriesSumHumanize }}
              </div>
              <v-divider
                class="my-2"
              />
              <div>
                <span class="text-caption">{{ $t('stocks.substocks.show.titleSimple') + ': ' }}</span>
                {{ details.subordinate_stock.name }}
              </div>
              <div>
                <span class="text-caption">{{ $t('tasks.moveProducts.type.label') + ': ' }}</span>
                {{ $t('tasks.moveProducts.type.' + movementType, [sourceString, destString]) }}
              </div>
              <div>
                <span class="text-caption"> {{ $t('tasks.strictMode.label') + ': ' }}</span>
                {{ $t('tasks.strictMode.' + details.transfer_mode) }}
                <v-tooltip right>
                  <template #activator="{ on }">
                    <span v-on="on"><v-icon>$info</v-icon></span>
                  </template>
                  <span>{{ $t('tasks.moveProducts.strictHint.' + details.transfer_mode) }}</span>
                </v-tooltip>
              </div>
              <div v-show="details.description">
                <span class="text-caption">{{ $t('tasks.description') + ': ' }}</span>
                {{ details.description }}
              </div>
              <v-divider
                class="my-2"
              />
              <EntityHistory :changes="details" />
            </v-container>
          </v-card>
        </v-flex>
        <v-flex
          v-show="details.notes.length > 0"
          md4
          xs12
        >
          <Notes :notes="details.notes" />
        </v-flex>
        <v-flex
          md4
          xs12
        >
          <TaskAttachments
            :attachments="details.attachments"
          />
        </v-flex>
      </v-layout>
      <TaskItemsCard
        :api="API"
        :card-type="TaskItemsCardType.ASSIGNMENT"
        :is-single="false"
        :items="items"
        :task-info="taskInfo"
        task-lang-path="moveProducts."
      />
    </template>
    <template v-else>
      <v-progress-linear
        indeterminate
      />
    </template>
  </div>
</template>

<script>
    import EntityHistory from "@/app/components/EntityHistory.component";
    import Notes from "@/app/tasks/components/TaskNotes.component";
    import TaskAttachments from "@/app/tasks/components/TaskAttachments.component";
    import {TaskMoveProductsMixin} from "@/app/mixins/TaskMoveProductsMixin";
    import TaskItemsCard from "@/app/tasks/components/taskItemsCard/TaskItemsCard.component";
    import {TaskItemsCardType} from "@/enum/task_items_card_type";
    import {TaskFetchItemsMixin} from "@/app/mixins/TaskFetchItemsMixin";
    import {TaskMoveProductsAPI as API} from "@/api/TaskMoveProductsAPI";

    export default {
        name: "MoveProductsAssignment",
        components: {TaskAttachments, Notes, EntityHistory, TaskItemsCard},
        mixins: [TaskMoveProductsMixin, TaskFetchItemsMixin],
        props: {
            taskInfo: {
                type: Object,
                default: () => ({})
            }
        },
        data: () => ({
            ready: false,
            items: [],
            TaskItemsCardType: TaskItemsCardType,
            API: API
        }),
        createdOrActivated: function (lifeCycleHook) {
            if (lifeCycleHook === this.LifeCycleHook.CREATED) {
                this.fetchItems({initial: true}).then(() => {
                    this.items = this.items.filter(item => item.quantity_to_move !== 0);
                    this.ready = true;
                }).catch(this.snack);
            } else {
                this.fetchItems().catch(this.snack);
            }
        }
    };
</script>

<style scoped>

</style>
